/* eslint-disable react/jsx-no-bind */
import React, { useCallback, useState, useMemo } from 'react'
import Drawer from '@groovehq/internal-design-system/lib/components/Drawer/UnmanagedDrawer'
import ModalBtns from '@groovehq/internal-design-system/lib/components/ModalBtns/ModalBtns'
import { useDrawer } from 'ducks/drawers/hooks'
import { buildDrawerQueryParam } from 'ducks/drawers/util'
import headerImg from '@groovehq/internal-design-system/lib/assets/images/mail-link.png'
import HeaderWithImage from '@groovehq/internal-design-system/lib/components/HeaderWithImage/HeaderWithImage'
import Selector from '../Selector'
import { CHANNEL_MAIN_TYPES } from '../Channels.data'

const AddChannelDrawer = ({ onClose }) => {
  const [selectedChannel, setSelectedChannel] = useState('email')

  const { drawerId: nextDrawerId, openDrawer: openNextDrawer } = useDrawer(
    CHANNEL_MAIN_TYPES[selectedChannel].drawer
  )

  const channelList = useMemo(() => {
    return Object.keys(CHANNEL_MAIN_TYPES).map(type => {
      const channel = {
        type,
        ...CHANNEL_MAIN_TYPES[type],
      }
      return channel
    })
  }, [])

  const handleOpenNextDrawer = useCallback(
    () => {
      openNextDrawer('new', {
        query: {
          ...buildDrawerQueryParam(
            nextDrawerId,
            'drawerChannelType',
            selectedChannel
          ),
        },
      })
    },
    [openNextDrawer, selectedChannel, nextDrawerId]
  )

  const footer = (
    <ModalBtns saveBtnText="Next step" onSave={handleOpenNextDrawer} />
  )

  return (
    <Drawer title="Add a channel" footer={footer} onClose={onClose}>
      <HeaderWithImage
        className="grui mt-5 mb-12"
        img={headerImg}
        alt="Channel"
        title="Choose a channel"
        intro="Let’s get your conversations flowing into Groove."
      />
      <Selector
        list={channelList}
        onSelect={setSelectedChannel}
        selected={selectedChannel}
      />
    </Drawer>
  )
}
export default AddChannelDrawer
